import { render, staticRenderFns } from "./spm-manage-detail.vue?vue&type=template&id=8219bf64&scoped=true"
import script from "./spm-manage-detail.vue?vue&type=script&lang=js"
export * from "./spm-manage-detail.vue?vue&type=script&lang=js"
import style0 from "./spm-manage-detail.vue?vue&type=style&index=0&id=8219bf64&scoped=true&lang=scss"
import style1 from "./spm-manage-detail.vue?vue&type=style&index=1&id=8219bf64&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8219bf64",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8219bf64')) {
      api.createRecord('8219bf64', component.options)
    } else {
      api.reload('8219bf64', component.options)
    }
    module.hot.accept("./spm-manage-detail.vue?vue&type=template&id=8219bf64&scoped=true", function () {
      api.rerender('8219bf64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/spm/spm-manage/spm-manage-detail.vue"
export default component.exports